import { DocumentEditorPage } from '@jarvis/platform-ui';

export function DocumentPreviewPage() {
  return <DocumentEditorPage mode="preview" filesLinkTo="/files" filesLinkLabel="Files" />;
}
